import React from 'react';

import { Button, FlexBox } from '@eltoro-ui/components';

interface FooterProps {
  onApprove: VoidFunction;
  onCancel: VoidFunction;
  activeCropper: boolean;
}

export default function CanvasEditorFooter({ onApprove, onCancel, activeCropper }: FooterProps) {
  return (
    <FlexBox alignItems="center" justifyContent="flex-end" UNSAFE_className="canvas-editor-footer">
      <FlexBox alignItems="center" gap="0.75rem">
        <Button weight="bold" size="l" onClick={onCancel}>
          Cancel
        </Button>
        <Button disabled={activeCropper} kind="primary" weight="bold" size="l" onClick={onApprove}>
          Approve Final Results
        </Button>
      </FlexBox>
    </FlexBox>
  );
}
